import React, { useState, useRef } from 'react';
import VideoFooter from './VideoFooter'
import './Video.css';
import VideoSidebar from './VideoSidebar'

function Video({
  url,
  channel,
  description,
  song,
  likes,
  messages,
  shares
}) {
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef(null);

  const onVideoPress = () => {
    if (playing) {
      videoRef.current.pause();
      setPlaying(false);
    } else {
      videoRef.current.play();
      setPlaying(true);
    }
  };

  return (
    <div className="video">
      <video 
      className="video_player" 
      loop
      onClick={onVideoPress} 
      ref = {videoRef}
      src={ url }></video>
      <VideoFooter channel={ channel }
      description={ description } 
      song={ song } />
      <VideoSidebar likes={ likes } messages={ messages } shares={ shares } />
    </div>
  );
}

export default Video;

// List of videos: https://v16m.tiktokcdn.com/cb948588ececb4dd660456c90880017a/5f377a4f/video/tos/useast2a/tos-useast2a-pve-0068/d87034d8567542a6a8242abd512a3e15/?a=1233&br=2442&bt=1221&cr=0&cs=0&dr=0&ds=3&er=&l=202008130601510101890741484605D5D4&lr=tiktok_m&mime_type=video_mp4&qs=0&rc=amg8dTlkaXY4djMzZzczM0ApOWRnZTpkO2U2N2U6NGZnNWdycXJgaTYzYG5fLS0vMTZzc19fYzZgYTYwYmNiYTM0NV46Yw%3D%3D&vl=&vr=

// https://v16m.tiktokcdn.com/441a3902b09dd9c2a688d3e6802c26d5/5f377a4f/video/tos/useast2a/tos-useast2a-ve-0068c004/9d9aa39ac1724458a9abc9f60abdc42c/?a=1233&br=1614&bt=807&cr=0&cs=0&dr=0&ds=3&er=&l=202008130601510101890741484605D5D4&lr=tiktok_m&mime_type=video_mp4&qs=0&rc=am1kZXdzcGltdjMzNTczM0ApM2RnOzloOzs8NzRoNTY1OWcxbS02L2VoMW1fLS0yMTZzczQuLTYuNC0wNWMvYzJiYGM6Yw%3D%3D&vl=&vr=

// https://v16m.tiktokcdn.com/8877e2fe957fb1405a7583f244f392d1/5f377a4f/video/tos/useast2a/tos-useast2a-ve-0068c003/a75076ab3f224ff7b8d1d9764ac87641/?a=1233&br=1542&bt=771&cr=0&cs=0&dr=0&ds=3&er=&l=202008130601510101890741484605D5D4&lr=tiktok_m&mime_type=video_mp4&qs=0&rc=MzN5bHE1NHg7djMzZzczM0ApNTs8ZTU1OTxnNzk0PGg2aGcvXjMzbGpvcm1fLS0yMTZzc141XjY2MS8tYy4vNTQwNGA6Yw%3D%3D&vl=&vr=

// https://v16m.tiktokcdn.com/aec9f97e7deb86c7ec3b4088da71be13/5f3789af/video/tos/useast2a/tos-useast2a-ve-0068c003/32689ab4f7684ea48d8ed0cf6330b1d9/?a=1233&br=2760&bt=1380&cr=0&cs=0&dr=0&ds=3&er=&l=202008130707270101890501595601D48D&lr=tiktok_m&mime_type=video_mp4&qs=0&rc=am1ucWlveHk7dTMzOjczM0ApOTdoNDxkaDxmN2U3ZWQzNGdzMWFsY25maWdfLS0yMTZzczMuMy8uM2IuYjViXjI1Yy86Yw%3D%3D&vl=&vr=

// https://v16m.tiktokcdn.com/951f212d967cf6604e8b49a35b5402a1/5f378a7f/video/tos/useast2a/tos-useast2a-pve-0068/eebed785ea684031986b196160e9a285/?a=1233&br=2894&bt=1447&cr=0&cs=0&dr=0&ds=3&er=&l=2020081307105501019020801302021F41&lr=tiktok_m&mime_type=video_mp4&qs=0&rc=amlvbXV1d25udDMzPDczM0ApNDY3Zzc2M2VlNzloNTQ6OmczaW80ay0xcGdfLS02MTZzc2BhNmEtYGA1X142Ll8wNjU6Yw%3D%3D&vl=&vr=

// https://v16m.tiktokcdn.com/dae5cc5a7b183237619015c354ccba40/5f378a7f/video/tos/useast2a/tos-useast2a-ve-0068c004/028e44b744674e11b8787bf38c5b5216/?a=1233&br=2146&bt=1073&cr=0&cs=0&dr=0&ds=3&er=&l=2020081307105501019020801302021F41&lr=tiktok_m&mime_type=video_mp4&qs=0&rc=M2tudWpxd21tdDMzaDczM0ApZWg8ZzdoOmU4N2g7ODM8ZGdubzBybjRnaTRfLS1gMTZzczQzLjVeX2EvMy5fNWEwMzM6Yw%3D%3D&vl=&vr=

// https://v16m.tiktokcdn.com/ecd537734470fc12420f327bb41eff93/5f378b15/video/tos/useast2a/tos-useast2a-ve-0068c001/44ec9bf34f724a54a2ca3058d533681b/?a=1233&br=7714&bt=3857&cr=0&cs=0&dr=0&ds=3&er=&l=202008130713250101901851373F024BFD&lr=tiktok_m&mime_type=video_mp4&qs=0&rc=MzVwcGtnN2s2czMzNjczM0ApNGQ4M2k4ZDxnN2llaDQ5Z2dmaC0wcWRzcGJfLS0zMTZzc2EzMV4xMy9hLmAvLzUwYmI6Yw%3D%3D&vl=&vr=

// https://v16m.tiktokcdn.com/6270c2fad746b8ba8d12283aff5799c6/5f377a4f/video/tos/useast2a/tos-useast2a-ve-0068c002/9c1a4d851f02405aaf6b3c7b9a803f63/?a=1233&br=1660&bt=830&cr=0&cs=0&dr=0&ds=3&er=&l=202008130601510101890741484605D5D4&lr=tiktok_m&mime_type=video_mp4&qs=0&rc=M3lqMzllOHU7djMzOzczM0ApZjxoNTZpZTs4NzM3Zzg4PGdvXzRqMi5iL25fLS0uMTZzczQuMjYuL141XzU2M2M0NC06Yw%3D%3D&vl=&vr=